import { Action } from '@web-components/invoices/invoice.model';

export interface Template {
	title: string;
	actions: TemplateActions;
}

export interface TemplateActions {
	EDIT: Action;
	DUPLICATE: Action;
	DELETE: Action;
}

export const TEMPLATE_MOCK_DATA: Array<Template> = [
	{
		title: 'Some template',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: 'Sohfgh fgh ',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: 'rq1111',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: 'tyutyut rg dfg',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: 'cvbcvb',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: 'ghj ghj ',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: 'we qwe ',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: 'dfgdfg sdfg ',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	},
	{
		title: '123123',
		actions: {
			EDIT: {
				state: null,
				message: 'Edit'
			},
			DUPLICATE: {
				state: null,
				message: 'Duplicate'
			},
			DELETE: {
				state: null,
				message: null
			}
		}
	}
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/settings/settings.model.ts